<template>
  <span>
    <!-- <div v-if="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone'">
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div slot="content">
          応対中 {{ this.$store.state.sysInit.manualChatUserCount }}件
        </div>
        <icon name="message" :scale="5"></icon>
      </el-tooltip>
      
    </div> -->

    <div>
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div
          slot="content"
          v-if="this.$store.state.sysInit.manualChatPiStatus != 'OnThePhone'"
        >
          {{ this.$store.state.sysInit.manualChatPiStatusText }}
        </div>
        <div slot="content" v-else>
          応対中 {{ this.$store.state.sysInit.manualChatUserCount }}件
        </div>

        <el-popover placement="bottom-end" width="150px" :offset="100"   v-model="visible">
          <!-- <el-select v-model="value" @change="piStatusChange()" placeholder="请选择" :disabled="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone'">
            <el-option
              v-for="item in this.$store.state.sysInit.manualChatPiStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
          <span style="float: left">
        <icon
            slot="reference"
            :name="item.value"
            :scale="5"
          ></icon>
        </span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
            </el-option>
          </el-select> -->
          <span
            v-if="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone'"
          >
            <el-table
              :data="$store.state.sysInit.manualChatPiStatusList"
              style="width: 100%"
              :show-header="false"
            >
              <el-table-column>
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    :disabled="scope.row.value == 'OnThePhone'"
                    v-if="scope.row.value == 'OnThePhone'"
                  >
                    <span style="margin-left: 25px;">
                     <img  slot="reference" :src="bindIcon(scope.row.value)"  style="width: 15px;height: 15px;"/>
                      <!-- <icon
                        slot="reference"
                        :name="scope.row.value"
                        :scale="5"
                      ></icon> -->
                    </span>
                    <span style="float: right; color: #8492a6; font-size: 12px;margin-left:15px">
                      {{ scope.row.label }}
                      <!-- {{ scope.row.label }} -->
                    </span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </span>
          <span v-else>
            <el-table
              :data="$store.state.sysInit.manualChatPiStatusList"
              style="width: 100%"
              :show-header="false"
            >
              <el-table-column>
                <template slot-scope="scope">
                  <el-button type="text" size="mini" :disabled="scope.row.value == 'OnThePhone'"  @click="piStatusChange_table(scope.row.value)">
                  <span style="margin-left: 25px;">
                     <img  slot="reference" :src="bindIcon(scope.row.value)"  style="width: 15px;height: 15px;"/>
                     <!-- "@/assets/images/tvlogo/"+icon+".png" -->
                    <!-- <icon
                      slot="reference"
                      :name="scope.row.value"
                      :scale="5"
                    ></icon> -->
                  </span>
                  <span style="float: right;color: #8492a6; font-size: 12px;margin-left: 15px;">
                      {{ scope.row.label }}
                  </span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </span>

<img v-if="this.$store.state.sysInit.manualChatPiStatus == 'Online'" style="width: 21px;height: 21px;margin-left:18px;" src="../assets/img/Online.png" slot="reference" />
<img v-if="this.$store.state.sysInit.manualChatPiStatus == 'OnThePhone'" style="width: 23px;height: 23px;margin-left: 18px;" src="../assets/img/OnThePhone.png" slot="reference" />
<img v-if="this.$store.state.sysInit.manualChatPiStatus == 'Away'" style="width: 23px;height: 23px;margin-left: 18px;" src="../assets/img/Away.png" slot="reference" />
<img v-if="this.$store.state.sysInit.manualChatPiStatus == 'Busy'" style="width: 23px;height: 23px;margin-left: 18px;" src="../assets/img/Busy.png" slot="reference" />
<img v-if="this.$store.state.sysInit.manualChatPiStatus == 'Offline'" style="width: 23px;height: 23px;margin-left: 18px;" src="../assets/img/Offline.png" slot="reference" />



        </el-popover>
      </el-tooltip>
    </div>
  </span>
</template>

<script>
import api from "@/api";
import { Message } from "element-ui";
import {
  orderBy,
  findIndex,
  reverse,
  sortBy,
  toPairs,
  find,
  chunk,
  remove,
  omit,
} from "lodash";
export default {
  data() {
    return {
      value: "",
      visible: false,
      text: "",
    };
  },
  watch: {
    "$store.state.sysInit.manualChatPiStatus": function () {
      if (this.$store.state.sysInit.manualChatPiStatus == "OnThePhone") {
        this.value = "応対中";
      }
      if (this.$store.state.sysInit.manualChatPiStatus == "Online") {
        this.value = "待機中";
      }
       if (this.$store.state.sysInit.manualChatPiStatus == "Busy") {
        this.value = "作業中";
      }
       if (this.$store.state.sysInit.manualChatPiStatus == "Away") {
        this.value = "応対不可";
      }
       if (this.$store.state.sysInit.manualChatPiStatus == "Offline") {
        this.value = "応対不可";
      }
    },
  },

  mounted() {
    this.text = this.$store.state.sysInit.manualChatPiStatusText;
    this.value = this.$store.state.sysInit.manualChatPiStatusText;
    console.log("this.value", this.value);
  },
  methods: {
    bindIcon(icon) {
	return require("@/assets/img/"+ icon+ ".png");
},
    piStatusChange() {
      let params = {
        userId: this.$store.state.sysInit.user_id,
        status: this.value,
      };
      console.log(params);
      api.changePiStatus(params).then((res) => {
        let tempObj = find(this.$store.state.sysInit.manualChatPiStatusList, [
          "value",
          this.value,
        ]);
        this.$store.state.sysInit.manualChatPiStatusText = tempObj.label;
        this.$store.state.sysInit.manualChatPiStatus = this.value;
        this.text = tempObj.label;
        Message.success({
          message:
            this.$store.state.sysInit.html_const.cons_258_personal_setting,
        });
      });
    },
    piStatusChange_table(row) {
      let val = row;
      let params = {
        userId: this.$store.state.sysInit.user_id,
        status: val,
      };
      console.log(params);
      api.changePiStatus(params).then((res) => {
        let tempObj = find(this.$store.state.sysInit.manualChatPiStatusList, [
          "value",
          val,
        ]);
        this.$store.state.sysInit.manualChatPiStatusText = tempObj.label;
        this.$store.state.sysInit.manualChatPiStatus = val;
        this.text = tempObj.label;
        Message.success({
          message:
            this.$store.state.sysInit.html_const.cons_258_personal_setting,
        });
      });
    },
    closeSelected() {
      this.value = this.text;
      this.visible = false;
    },
  },
};
</script>

<style>
</style>